import { isFunc } from '../utils/common';
import { FnMapper, ParallelOptions } from './piterate';
import { pqueue } from './pqueue';

/**
 * This overload has no options
 * @param iterable
 * @param fnMapper
 */
export async function pmap<T, U>(iterable: Iterable<T>, fnMapper: FnMapper<T, U>): Promise<U[]>;
/**
 * This overload has options before callback
 * @param iterable
 * @param options
 * @param fnMapper
 */
export async function pmap<T, U>(
	iterable: Iterable<T>,
	options: ParallelOptions | undefined,
	fnMapper: FnMapper<T, U>
): Promise<U[]>;
/**
 * Allows async mapping of an iterable, and returns results as an array.
 * Result order IS guaranteed to match input order.
 *
 * This overload has options after mapper
 * @deprecated
 * @param iterable
 * @param fnMapper
 * @param options
 */
export async function pmap<T, U>(
	iterable: Iterable<T>,
	fnMapper: FnMapper<T, U>,
	options: ParallelOptions | undefined,
	errMsg?: string
): Promise<U[]>;
export async function pmap<T, U>(
	iterable: Iterable<T>,
	arg1: ParallelOptions | undefined | FnMapper<T, U>,
	arg2?: ParallelOptions | undefined | FnMapper<T, U>,
	arg3?: string
): Promise<U[]> {
	// Extra complications for the overloads
	let fnMapper: FnMapper<T, U>;
	let options: ParallelOptions | undefined;
	let errMsg: string | undefined;

	if (isFunc(arg1)) {
		fnMapper = arg1;
		options = arg2 as ParallelOptions | undefined;
		errMsg = arg3;
	} else {
		options = arg1;
		fnMapper = arg2 as FnMapper<T, U>;
	}

	const results: U[] = [];

	await pqueue(
		iterable,
		{
			...options,
			errMsg: errMsg ?? options?.errMsg,
		},
		fnMapper,
		(result, index) => {
			results.push(result);
		}
	);

	return results;
}
